import { render, staticRenderFns } from "./Servisler.vue?vue&type=template&id=b6b5407a"
import script from "./Servisler.vue?vue&type=script&lang=ts"
export * from "./Servisler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports